export default "__VITE_ASSET__gkyPuvFv__"